import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import type { IChatRoomSubscriberCandidate } from './types';

export function useChatRoomSubscriberCandidates(chatRoomId: string | null) {
  const url = chatRoomId
    ? `chatRoom/${chatRoomId}/subscriber-candidates`
    : null;

  const { data, error, isLoading, mutate } = useSWR<{
    candidates: IChatRoomSubscriberCandidate[];
    canManageCustomerSubscribers: boolean;
  }>(url, url ? SWRFetcher({ method: 'GET' }) : null, {
    revalidateOnFocus: true,
  });

  return {
    candidates: data?.candidates ?? [],
    canManageCustomerSubscribers: data?.canManageCustomerSubscribers ?? false,
    error,
    isLoading,
    mutate,
  };
}
